import { FC, PropsWithChildren, memo, useCallback } from 'react';
import { ButtonWrapper } from '@tempusfinance/common-ui';

import './ButtonPrimary.scss';
import LoadingIndicator from '../LoadingIndicator';
import { LoadingColor } from '../LoadingIndicator/LoadingIndicator';

interface ButtonPrimaryProps {
  loading?: boolean;
  disabled?: boolean;
  loadingColor?: LoadingColor;
  size?: 'lg' | 'sm';
  fullWidth?: boolean;
  onClick?: () => void;
}

const ButtonPrimaryComponent: FC<PropsWithChildren<ButtonPrimaryProps>> = ({
  children,
  loading = false,
  disabled = false,
  loadingColor = 'default',
  size = 'sm',
  fullWidth = false,
  onClick,
}) => {
  const handleClick = useCallback(() => {
    if (!loading && !disabled) {
      onClick?.();
    }
  }, [loading, disabled, onClick]);

  return (
    <ButtonWrapper onClick={handleClick} disabled={disabled || loading} fullWidth={fullWidth}>
      <div
        className="nostra__buttonPrimary"
        data-loading={loading}
        data-disabled={disabled}
        data-size={size}
        data-full-width={fullWidth}
      >
        {loading && (
          <div className="nostra__buttonPrimary__loading">
            <LoadingIndicator size={16} color={loadingColor} />
          </div>
        )}
        {children}
      </div>
    </ButtonWrapper>
  );
};
export const ButtonPrimary = memo(ButtonPrimaryComponent);
